// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postAuthorizedDriver } from '../../services/VehiclesService';
import { VehicleAuthorizedDriverPostResponse, VehicleAuthorizedDriverPostRequest } from '../../types/Vehicles';

type Result = UseMutationResult<VehicleAuthorizedDriverPostResponse, Error, VehicleAuthorizedDriverPostRequest>;

function usePostAuthorizedDriver(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postAuthorizedDriver, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['authorized-drivers'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostAuthorizedDriver;
